import React from 'react';
import useUserProfile from 'hooks/useKeycloakUser';
import { useLocation, useNavigate } from 'react-router-dom';

const Login: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const ref = queryParams.get('ref') || '/';

  const { keycloak } = useUserProfile(() => {
    navigate(ref);
  });

  return (
    <>
      {!keycloak.authenticated ? (
        <div className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-br bg-purple-900">
          <div className="bg-white rounded-lg shadow-lg p-8 w-full max-w-md">
            <h2 className="text-2xl font-bold mb-6 text-center text-gray-800">
              Войти в familia launcher
            </h2>
            <button
              className="w-full py-3 px-6 bg-purple-900 text-white rounded-lg font-semibold hover:opacity-[.8] transition"
              onClick={() => keycloak.login()}
            >
              Войти
            </button>
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  );
};

export default Login;
